<template>
  <div class="newRoll">
    <div class="picShow">
      <a v-for="(item,index) in specialLabel.list" :key="index +''" @click="intoSpecial(item)">
        <div class="topicImg">
          <img :src="item.index_image" />
        </div>
        <div>
          <p class="topicText">
            <span
              v-text="isGaonS?(isEnglish&&((item.cname||'').indexOf('*##*')!=-1)?(item.cname||'').split('*##*')[1]:(item.cname||'').split('*##*')[0]):item.cname"
            ></span>
          </p>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import {
  getModuleInfo,
  newtitle,
  getModulStyle,
  newtitle1,
  getResource
} from "./../services/api.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      //mainbottom
      activeIndex: "0",
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      label: {
        id: "",
        list: []
      }
    };
  },
  props: {
    value: {
      type: String,
      default() {
        return "";
      }
    },
    special: {
      type: Object,
      default() {
        return {
          id: "",
          data: [{ group_index_image: "", group_title: "" }]
        };
      }
    },
    specialLabel: {
      type: Object,
      default() {
        return {
          list: [{ pid: 0 }]
        };
      }
    }
  },
  computed: {
    ...mapGetters(["webID", "isGaonS", "isEnglish"]),
    specialLabelIndex() {
      if (this.specialLabel && this.specialLabel.list.length > 0) {
        if (this.specialLabel.list[0]) {
          return this.specialLabel.list[0].pid + "";
        }
      } else {
        return "0";
      }
    },
    specialType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    special() {}
  },
  mounted() {
    var id = setInterval(() => {
      if (this.specialLabel.id !== "") {
        clearInterval(id);
      }
    });
  },
  methods: {
    handleSelect(index) {
      this.specialType = index;
    },

    intoSpecial(item) {
      // var textdesc = "全部专题";

      // if (this.specialLabel) {
      //   var res = this.specialLabel.list.filter(o => o.id == this.specialType);
      //   if (res.length == 0) {
      //     textdesc = "全部专题";
      //   } else {
      //     textdesc = res[0].cname;
      //   }
      // }
      this.$router.push({
        path: "/intopic",
        query: {
          category: item.id,
          bigimg: item.index_image,
          text: item.cname
        }
      });
    },
    ...mapActions(["setCurSpecial"])
  }
};
</script>
<style lang="less" scoped>
.newRoll {
  width: 100%;
  height: 100%;
  margin: 30px 0 auto;
  .nav {
    width: 100%;
    margin-bottom: 24px;
    .el-menu-demo {
      border-bottom: none;
      height: 40px;
      .is-active.el-menu-item {
        color: #f05941;
      }
      .el-menu-item {
        border-bottom-color: #f05941;
        margin-right: 49px;
        padding: 0;
        color: #000;
        height: 40px;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
  .picShow {
    width: 100%;
    overflow: hidden;
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    /*padding-top:20px;*/
    &::after {
      //处理图片最后一行
      content: "";
      flex-grow: 999999;
    }
    a {
      cursor: pointer;
      float: left;
      margin-right: 20px;
      position: relative;
      display: inline-block;
      margin-top: 20px;
      width: 386px;
      // height: 252px;
      .topicImg {
        width: 386px;
        // height: 200px;
        border: 1px solid #eeeff2;
        border-bottom: 0;
        img {
          width: 100%;
          height: 100%;
          display: block;
          // object-fit: cover;
        }
      }
      .topicText {
        // position: absolute;
        left: 0;
        bottom: 0;
        color: #555555;
        font-size: 24px;
        width: 386px;
        height: 50px;
        border: 1px solid #eeeff2;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          display: block;
          width: 369px;
          height: 16px;
          font-size: 14px;
          text-align: center;
          color: rgba(85, 85, 85, 1);
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:nth-child(1) {
        margin-top: 0;
      }
      &:nth-child(2) {
        margin-top: 0;
      }
      &:nth-child(3) {
        margin-top: 0;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/allTopic.vue